import axios from 'axios'
import Qs from 'qs'
import {Message} from 'element-ui';
import router from'../router'
import { myLoginDialog,myRegisterDialog } from '../store';


router.push('/');


// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: '/myapi',
   // baseURL:'http://pay.ccmaple.cc/myapi',
  // baseURL:'http://127.0.0.1:8082',
    // 超时
    timeout: 1200000
  })
  service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
 // service.defaults.headers.post['timestampHL'] = 123456;
//service.defaults.headers.post['versionHL'] = '1.0.0';
  service.defaults.withCredentials = true;
//axios.defaults.headers.Authorization=window.sessionStorage.getItem("token");
//axios.defaults.headers.Authorization=JSON.parse(window.sessionStorage.getItem("token"))
service.interceptors.response.use(success => {
    if(success.data.code == 1001){
        Message.error({message: success.data.msg});
        //router.push({path:"/my"})
        myLoginDialog({dialogVisible:true,btnName:'登录',pageType:0},{});
        return;
    }
    if(success.data.code == 101){
        Message.error({message: success.data.msg});
        return;
    }
    if(success.data.code > 0){
        Message.error({message: success.data.msg});
        return;
    }
    if (success.status && success.status == 200 && success.data.status > 0) {
        Message.error({message: success.data.msg})
        return;
    }
    if (success.data.err == 0) {

        if(success.headers.token){
            window.sessionStorage.setItem("token", success.headers.token);
        }

       // Message.success({message: success.data.msg})
    }
    return success.data;
}, error => {
    if (error.response.status == 504 || error.response.status == 404) {
        Message.error({message: '服务器被吃了( ╯□╰ )'})
    } else if (error.response.status == 403) {
        Message.error({message: '权限不足，请联系管理员'})
    } else if (error.response.status == 401) {
        Message.error({message: error.response.data.msg ? error.response.data.msg : '尚未登录，请登录'})
       
    } else {
        if (error.response.data.msg) {
            Message.error({message: error.response.data.msg})
        } else {
            Message.error({message: '未知错误!'})
        }
    }
    return;
})




//let base = 'http://localhost:8090';
let base = 'https://api.bianyl.xyz';
export const getBase = () => {
    if (process.env.NODE_ENV == "production") {
        //生产环境
        base = 'https://api.bianyl.xyz';
    }
    return base;
}
export const gethistorys = (title,name,content)=>{
    let s = window.sessionStorage.getItem("array");
    
    if(title){
        let historys = {};
        historys.title=title;
        historys.name=name;
        historys.content=content;

        if(window.sessionStorage.getItem("array")){
            s = s + "~" + JSON.stringify(historys);
        }else{
            s = JSON.stringify(historys);
        }
        
        window.sessionStorage.setItem("array",s)
    }
    let array = s.split("~")
    let element = [] 
    for (let index = 0; index < array.length; index++) {
        element[index] = JSON.parse(array[index]);
        
    }
    console.log(element)
    return element;
}

//let base = 'https://apitest.hooply.com';
export const postKeyValueRequest = (url, params) => {

    return service({
        method: 'post',
        url: `${url}`,
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let i in data) {
                ret += encodeURIComponent(i) + '=' + encodeURIComponent(data[i]) + '&'
            }
            return ret;
        }],
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'loginType' : 1
        }
    });
}

export const postRequest = (url, params) => {
    return service({
        method: 'post',
        url: `${url}`,
        data:  Qs.stringify(params)
    })
}
export const putRequest = (url, params) => {
    return service({
        method: 'put',
        url: `${url}`,
        data: params
    })
}
export const getRequest = (url, params) => {
    return service({
        method: 'get',
        url: `${url}`,
        params: params
    })
}
export const deleteRequest = (url, params) => {
    return service({
        method: 'delete',
        url: `${url}`,
        params: params
    })
}



export const timestampToTime = (timestamp) => {
    var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    // let Y = date.getFullYear() + '-';
    // let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
    // let D = date.getDate() + ' ';
    // let h = date.getHours() + ':';
    // let m = date.getMinutes() + ':';
    // let s = date.getSeconds();
    // return Y+this.padLeftZero(M)+this.padLeftZero(D)+this.padLeftZero(h)+this.padLeftZero(m)+this.padLeftZero(s);
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? ('0' + MM) : MM;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    let h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    let m = date.getMinutes();
    m = m < 10 ? ('0' + m) : m;
    let s = date.getSeconds();
    s = s < 10 ? ('0' + s) : s;
    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
}

export const saveLoginInfo = (userInfo) => {
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
}

export const getLoginInfo = () => {
    return JSON.parse(localStorage.getItem('userInfo'));
}

//let base = 'https://apitest.hooply.com';
export const goLoginPage = () => {
    myLoginDialog({dialogVisible:true,btnName:'登录',pageType:0},{});   
}
export const goRegisterPage = () => {
    myRegisterDialog({dialogVisible:true,btnName:"注册",pageType:1},{});   
}
export const goEditPwdPage = (reuserInfo) => {
    myRegisterDialog({dialogVisible:true,btnName:"修改密码",pageType:0, form: {email: reuserInfo.email}},{});   
}